<template>
    <div class="_heroContent">
        <div class="_heroIn">

            <div class="_heroLine">
                We Simplify<br/>
                Implant Dentistry.
                <!-- {{localize('hp_maintitle')}} -->
            </div>
            
            <!-- todo: add circle blue button with + inside) on rollover: fill blue make + white -->
<!--             <div class="center text-center btnExWrapper">
                <a class="btnExplore" href="https://www.mis-implants.com/company/story-and-values" >
                    <span>{{localize('our_story')}}</span>                    
                </a>
            </div>
            <a title="Our Story" class="btnExplore" href="https://www.mis-implants.com/company/story-and-values" >
                <i class="fal fa-plus"></i>
                <span>{{localize('our_story')}}</span>
            </a>
 -->
            <div class="center text-center btnExWrapper1">
                <a :class="['_cta',$route.params.locale]"
                        title="Our Story" 
                        href="https://www.mis-implants.com/company/story-and-values">
                    <i class="fal fa-plus"></i>
                    <span :class="['button-text']">{{localize('our_story')}}</span>
                </a>
            </div>

        </div>
    </div>        
</template>

<!-- <i class="fal fa-chevron-right"></i> -->

<script>
    export default {
        methods:{
            scrollToVideo()
            {
                const id = 'homeHeroVideo1';
                const yOffset = -150; 
                const element = document.getElementById(id);
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});

                //document.getElementById("homeHeroVideo1").scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

</script>


<style>

    ._cta {
        width: 40px;
        height: 40px;
        border-radius: 40px;
        border: 1px solid #0f70b6;
        background-color: transparent;
        color: #fff;
        transition: width 0.7s;
        display: block;
        position: relative;
        overflow: hidden;
        transition: all 0.7s;
    }
    ._cta:hover {
        width: 120px;
        background-color: #0f70b6;
    }
    ._cta.de-de:hover {
        width: 160px;
    }
    ._cta.es-es:hover {
        width: 160px;
    }
    ._cta.fr-fr:hover {
        width: 140px;
    }

    ._cta i {
        opacity: 1;
        transition: opacity 0.5s;
        color:#0f70b6;
        position: absolute;
        top:50%;left: 50%;
        transform: translate(-50%,-50%);
    }

    ._cta:hover i {
        opacity: 0;        
    }

    ._cta .button-text {
        opacity: 0;
        transition: opacity .3s;
        position: absolute;
        width: 200px;
        text-align: center;
        left: 50%;
        top:50%;
        transform: translate(-50%,-50%);
        color: #fff;
        font-weight: 400 !important;
        font-size: 15px;
    }

    ._cta:hover .button-text {
        opacity: 1;
        transition: opacity 0.5s
    }

    ._heroContent
    {
        width: 100%;
        height: auto;
        text-align: left;
        display: flex;
        margin-top: 30px;
    }
    ._heroIn
    {
        margin: auto;
        width: 80vw;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        padding: 3vw 0px 3vw 0px;
        position: relative;
    }
    ._heroLogo
    {
        padding-top: 20px;
        width: 20vw;
        height: auto;
        margin: auto;
        display: block;
    }
    ._heroLine
    {
        padding-top: 0px;
        display: block;
        clear: both;
        font-size: clamp(30px,2.5vw,80px);
        line-height: clamp(30px,2.5vw,80px);
        color:#0f70b6;
        text-align: left;
        font-weight: 300 !important;
        letter-spacing: -2px !important;
        flex: 1;
    }
    ._heroText
    {
        padding-top: 40px;
        display: block;
        clear: both;
        font-size: 18px;
        color: #414141;
        text-align: center;
        width: 40vw;
        margin: auto;
        font-weight: 300 !important;
        letter-spacing: -0.5px !important;
    }


    .btnExplore
    {
        /* background-color: #0f70b6; */
        border:1px solid #0f70b6;
        cursor:pointer;
        position:relative;        
        text-align:center;
        
        transition: all ease 0.4s;     
        position: absolute;         
        bottom: 2.5vw;
        right: 0px;
        width: 2vw;
        height: 2.5vw;
        overflow: hidden;
        border-radius:2.5vw;

    }
    .btnExplore span
    {
        color:#ffffff;
        font-size: 14px;
        font-weight: 300 !important;
        padding-right: 0px !important;
        display: none;
    }
    .btnExplore i
    {
        color:#0f70b6;
        font-size: 14px;
        font-weight: 300 !important;
    }
    .btnExWrapper1
    {
        /* margin-top: 2.5vw;margin-bottom: 2.5vw; */
    }


  @media (hover: hover) {
    .btnExplore:hover i
    {
        color:#fff;
    }
    .btnExplore:hover
    {
        border:1px solid #0f70b6;
        background-color: #0f70b6;
    }
    .btnExplore:hover span
    {
        color:#fff;
    }
    }


    @media screen and (min-width: 1900px) {
        ._heroText
        {
            width: 50%;
            margin: auto;
        }
    }
    
    /* Portrait ipad pro */
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: portrait) 
      and (-webkit-min-device-pixel-ratio: 1.5) {
        ._heroContent {
            margin: 10vw 0 5vw 0px;
            height: auto;
        }        
      }       

    /* ----------- mobile ----------- */
    @media screen and (max-width: 815px) {
        ._heroContent{height: auto;}
        ._heroIn {width: 80vw;}        
        ._heroLogo{width: 70vw;padding: 30px 0px;}
        ._heroLine{
            padding-top: 10vw;
            padding-bottom: 10vw;
            font-size: 11vw;
            line-height: 11vw;
        }
        ._heroText
        {
            width: 100%;
        }
        .btnExWrapper1
        {
            padding-bottom: 10vw;
        }
        .btnExplore
        {
            /* display: none; */
        }
    }


</style>